import React, { useEffect, useState } from "react";
import s from './writingAnalysis.module.css';
import {getData, postData} from '../middleware/apiMiddleware';
import { useNavigate, useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import {MyInput} from '../components/Utilities/MyInput';

import {GreenButton, BlueButton, RedButton} from '../components/MyButton';
import {
  useSearchParams
} from "react-router-dom";

import {modifiedDate} from '../middleware/dateControl';
import {unsecuredCopyToClipboard} from '../middleware/clipboardService';

export default function WritingAnalysis() {
	const navigate = useNavigate();
	
	let [searchParams, setSearchParams] = useSearchParams();
	let page = searchParams.get("page");
	let limit = searchParams.get("limit");
	let id = searchParams.get("id");
	
	if (!page) {
		page = 1;
	}
	
	if (!limit) {
		limit = 20
	}
	
	let [userWritings, setUserWritings] = useState([]);
	let [uwId, setUwId] = useState(null);
	//fail, writing id, nickname
	let [currentType, setCurrentType] = useState("fail");
	let [cMarkingScheme, setCMarkingScheme] = useState("NO-SCORING");
	
	
	const changeMarkingScheme = () => {
		if (cMarkingScheme == 'NO-SCORING') {
			setCMarkingScheme('TSA');
		} else if (cMarkingScheme == 'PRE-DSE') {
			setCMarkingScheme('NO-SCORING');
		} else if (cMarkingScheme == 'JUNIOR-FORM') {
			setCMarkingScheme('PRE-DSE');		
		} else if (cMarkingScheme == 'DSE') {
			setCMarkingScheme('JUNIOR-FORM');		
		} else {
			setCMarkingScheme('DSE');		
		}
	}
	
	const listByScheme = () => {
		setCurrentType('scheme')
			getData('userWritingApi/listByScheme?page=' + page + '&limit=' + limit + '&scheme=' + cMarkingScheme, navigate)
				.then(res => {
					setUserWritings(res.data);
				}
			);
	}
	const listAllFail = () => {
		setCurrentType('fail')
			getData('userWritingApi/listFailWriting?page=' + page + '&limit=' + limit, navigate)
				.then(res => {
					setUserWritings(res.data);
				}
			);
	}
	
	const searchById = () => {
		setCurrentType('id')
		getData('userWritingApi/getById?id=' + uwId, navigate)
			.then(res => {
				setUserWritings(res.data);
			}
		);
	}
	
	const searchByNickname = () => {
		setCurrentType('nickname')
		getData('userWritingApi/listWritingByNickname?nickname=' + uwId, navigate)
			.then(res => {
				setUserWritings(res.data);
			}
		);
	
	}
	
	
	const searchByIdentifier = () => {
		setCurrentType('identifier')
		
		let obj = {identifier:uwId};
		postData("userWritingApi/listWritingByIdentifier", obj, navigate)
			.then(res => {
				setUserWritings(res.data);
			}
		);
		/*
		getData('userWritingApi/listWritingByIdentifier?identifier=' + uwId, navigate)
			.then(res => {
				setUserWritings(res.data);
			}
		);
	*/
	}
	
	
	
	const fetchData = () => {
		if (currentType == 'fail') {
			listAllFail();
		} else if (currentType == 'id') {
			searchById();
		} else if (currentType == 'nickname') {
			searchByNickname();
		}  else if (currentType == 'scheme') {
			listByScheme();
		} 
	}
	
	
	
	
	const rerunUserWriting = async (id) => {	
		let obj = {id};
		await postData("userWritingApi/rerunUserWriting", obj, navigate)
		
		obj = { userWritingId:id }
		await postData("writingLogicApi/replicateTrigger", obj, navigate)
		
		fetchData();
	}
	
	const rerunAllUserWriting = async () => {	
	
		for (let i of userWritings) {
			let obj = {id:i.id};
			postData("userWritingApi/rerunUserWriting", obj, navigate)
		}
	
		for (let i of userWritings) {
			let obj = { userWritingId:i.id }
			postData("writingLogicApi/replicateTrigger", obj, navigate)
		}
		
		fetchData();
	}
	
	useEffect(() => {
		listAllFail();
		
	}, []);
	return (<div>
	
		<div style={{margin:"10px 0", fontSize:"0.8rem"}}>
			<div style={{display:"flex", margin:"10px", padding:"10px", gap:"10px"}}>
				<div>
					<RedButton isEnabled={true} clickedAction={rerunAllUserWriting} bText="Rerun All" />
				</div>
				
				<div style={{display:"flex", padding:"2px", border:"1px solid #c9701c", borderRadius:"5px"}}>
					<div>
						<BlueButton isEnabled={true} clickedAction={listByScheme} bText="list by Scheme" />
					</div>
					<div style={{width:"120px", textAlign:"right"}}>
						<BlueButton isEnabled={true} clickedAction={()=>changeMarkingScheme()} bText={cMarkingScheme} />
					</div>
				</div>
				
				<div>
					<BlueButton isEnabled={true} clickedAction={listAllFail} bText="list fail" />
				</div>
				
				<div style={{display:"flex"}}>
					<MyInput inputLabel={"Search"} dataInput={uwId} changeAction={(e)=>{
						setUwId(e)
					}} />
					
					<div style={{display:"flex", gap:"5px"}}>
						<div>
							<GreenButton isEnabled={true} clickedAction={searchById} bText="By User Id" />	
						</div>
						<div>
							<GreenButton isEnabled={true} clickedAction={searchByNickname} bText="By Nickname" />
						</div>	
						<div>
							<GreenButton isEnabled={true} clickedAction={searchByIdentifier} bText="By Identifier" />
						</div>		
					</div>		
				</div>		
				
			</div>
		
			<div style={{display:"flex", gap:"10px", margin:"10px 10px 0 10px"}}>
				<div style={{flex: '0 0 80px'}}>Writing Id</div>
				<div style={{flex: '0 0 80px'}}>Identifier</div>
				<div style={{flex: '0 0 80px'}}>Student Id</div>
			</div>
			{
				userWritings.map((d, indexD) => (<div key={indexD + "userWritings"} style={{display:"flex", gap:"10px", margin:"10px", alignItems:"center"}}>
					
					<div style={{flex: '0 0 80px'}}>		
						<BlueButton isEnabled={true} clickedAction={()=>{ unsecuredCopyToClipboard(d.id); }} bText={d.id} />
					</div>
					<div style={{flex: '0 0 80px'}}>		
						<BlueButton isEnabled={true} clickedAction={()=>{ unsecuredCopyToClipboard(d.identifier); }} bText="identifier" />
					</div>
					<div style={{flex: '0 0 80px'}}>		
						<BlueButton isEnabled={true} clickedAction={()=>{ unsecuredCopyToClipboard(d.studentId); }} bText={d.studentId}  />
					</div>
					<div>
						<GreenButton isEnabled={true} clickedAction={()=>{ rerunUserWriting(d.id) }} bText="Rerun" />
					</div>
					<div style={{flex: '0 0 80px', fontWeight:"bold"}}>{d.engine}</div>
					<div style={{flex: '0 0 100px', fontWeight:"bold"}}>{d.markingScheme}</div>
					<div>
						<Link to={`https://legacy.ehla-school.pages.dev/assignment/1-1/writing-ai/${d.identifier}`} target="_blank" rel="noopener noreferrer" className="billBtn billBtn-default">
							check
						</Link>
					</div>
					
					<div style={{flex: '0 0 50px'}}>	
							{(d.aiStatus == 'completed') && (<GreenButton isEnabled={true} bText={d.aiStatus} />) }
							{(d.aiStatus != 'completed') && (<RedButton isEnabled={true} bText={d.aiStatus} />) }
					</div>
					<div style={{textAlign:"left"}}>	
						<div onClick={()=>{ unsecuredCopyToClipboard(d.username); }}>{d.username}</div>
						<div onClick={()=>{ unsecuredCopyToClipboard(d.nickname); }}>{d.nickname}</div>
					</div>
					
				</div>))
			}
		
		</div>
	
	</div>);
}

